import React from 'react';

import { WebUiGlobalProvider } from './context/global/global-provider';
import WebUi from './WebUI';

export default function WebUiApp() {
  return (
    <WebUiGlobalProvider>
      <WebUi />
    </WebUiGlobalProvider>
  );
}
